(ns kyber.styles.markup-editor)

(def min-editor-height 350)

(defn markup-editor
  [gs]
  {".DraftEditor-root"
   {:margin :auto
    :height (str min-editor-height "px")
    :min-height (str min-editor-height "px")
    :overflow-y :scroll
    :padding [[(gs [:spacing :p20])
               (gs [:spacing :p8])
               (gs [:spacing :p20])
               (gs [:spacing :p8])]]
    :border-radius [[(gs [:radius :r0])
                     (gs [:radius :r0])
                     (gs [:radius :r7])
                     (gs [:radius :r7])]]
    :border (str "1px solid " (gs [:colors :gray-scale-200]))

    "& > *"
    {:font-family (gs [:font-family :open-sans])
     :font-size (gs [:font-size :body-20])

     "& h1"
     {:font-weight (gs [:font-weight :title-40])
      :font-size (gs [:font-size :title-40])}
     "& h2"
     {:font-weight (gs [:font-weight :title-30])
      :font-size (gs [:font-size :title-30])}
     "& h3"
     {:font-weight (gs [:font-weight :title-20])
      :font-size (gs [:font-size :title-20])}}}

   ".DraftEditor-editorContainer"
   {:height "100%"
    :z-index 0}

   ".public-DraftEditor-content"
   {:height "100%"
    :min-height (str min-editor-height "px")}

   ".full-size-editor"
   {"& > .DraftEditor-root"
    {:overflow :inherit
     :height :auto}}})
